import React from 'react';
import { Button } from './ui/button';
import { Trophy, RotateCcw, ArrowLeft, Share2, Swords } from 'lucide-react';
import LoginButton from './LoginButton';

const WhichingGameOver = ({
  isWinner,
  score,
  maxWinStreak,
  maxStrikes,
  challengeData,
  user,
  scoreSubmitted,
  isCreatingChallenge,
  onPlayAgain,
  onChangeDeck,
  onCreateChallenge,
  onShareScore,
  onViewLeaderboard
}) => {
  return (
    <div className="text-center">
      <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 sm:p-8 max-w-md mx-auto">
        {isWinner ? (
          <>
            <div className="text-6xl mb-4">🏆</div>
            <h2 className="text-3xl font-bold text-yellow-400 mb-4">VICTORY!</h2>
            <p className="text-xl text-white mb-2">
              You conquered the deck!
            </p>
            <p className="text-2xl text-green-400 font-bold mb-4">
              Final Score: {score}
            </p>
          </>
        ) : (
          <>
            <h2 className="text-3xl font-bold text-red-400 mb-4">
              Game Over! 🎮
            </h2>
            <p className="text-2xl text-white mb-2">
              Final Score: <span className="text-green-400 font-bold">{score}</span>
            </p>
            <p className="text-xl text-orange-300 mb-2">
              Best Streak: <span className="font-bold">{maxWinStreak}</span> 🔥
            </p>
            <p className="text-xl text-red-300 mb-4">
              {maxStrikes} Strikes - You're Out!
            </p>
          </>
        )}
        
        {/* Challenge Result */}
        {challengeData && (
          <div className={`mb-4 p-3 rounded-lg ${
            score > challengeData.score_to_beat 
              ? 'bg-green-600/50' 
              : score === challengeData.score_to_beat 
                ? 'bg-yellow-600/50' 
                : 'bg-red-600/50'
          }`}>
            {score > challengeData.score_to_beat ? (
              <p className="text-white font-bold">🏆 You beat {challengeData.challenger_name}'s score of {challengeData.score_to_beat}!</p>
            ) : score === challengeData.score_to_beat ? (
              <p className="text-white font-bold">🤝 Tied with {challengeData.challenger_name}! ({challengeData.score_to_beat})</p>
            ) : (
              <p className="text-white font-bold">😤 {challengeData.challenger_name} wins! (Their score: {challengeData.score_to_beat})</p>
            )}
          </div>
        )}
        
        {/* Score saved indicator */}
        {user && scoreSubmitted && (
          <p className="text-green-400 mb-4">✅ Score saved to leaderboard!</p>
        )}
        {!user && (
          <div className="mb-4">
            <p className="text-gray-300 mb-2">Sign in to save your scores!</p>
            <LoginButton />
          </div>
        )}
        
        <div className="flex justify-center gap-4 flex-wrap">
          <Button
            onClick={onPlayAgain}
            size="lg"
            className="bg-green-600 hover:bg-green-700 text-white px-8 py-6 text-lg font-semibold"
          >
            <RotateCcw className="w-5 h-5 mr-2" />
            Play Again
          </Button>
          <Button
            onClick={onChangeDeck}
            size="lg"
            variant="outline"
            className="bg-white/10 border-gray-300 text-white hover:bg-white/20 px-8 py-6 text-lg font-semibold"
          >
            <ArrowLeft className="w-5 h-5 mr-2" />
            Change Deck
          </Button>
          <Button
            onClick={onCreateChallenge}
            size="lg"
            variant="outline"
            disabled={isCreatingChallenge}
            className="bg-orange-600/50 border-orange-400 text-white hover:bg-orange-600 px-8 py-6 text-lg font-semibold"
          >
            <Swords className="w-5 h-5 mr-2" />
            {isCreatingChallenge ? 'Creating...' : 'Challenge a Friend'}
          </Button>
          <Button
            onClick={onShareScore}
            size="lg"
            variant="outline"
            className="bg-blue-600/50 border-blue-400 text-white hover:bg-blue-600 px-8 py-6 text-lg font-semibold"
          >
            <Share2 className="w-5 h-5 mr-2" />
            Share Score
          </Button>
          {user && (
            <Button
              onClick={onViewLeaderboard}
              size="lg"
              variant="outline"
              className="bg-purple-600/50 border-purple-400 text-white hover:bg-purple-600 px-8 py-6 text-lg font-semibold"
            >
              <Trophy className="w-5 h-5 mr-2" />
              Leaderboard
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default WhichingGameOver;
